module.exports = __webpack_public_path__ + "static/bottom_bar_3-ca9f9efe4f2a2ab0b8072c207d6a94cf.png";